import { ListFilter } from "lucide-react";
import { CARD_CLASS } from "../styles";

type Props = {
  label?: string;
};

export default function FiltersLoadingPlaceholder({ label = "Загружаем фильтры..." }: Props) {
  return (
    <section className={`${CARD_CLASS} overflow-hidden`}>
      <div className="flex items-center gap-3">
        <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-slate-100 text-slate-500">
          <ListFilter size={18} />
        </span>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">Фильтры</p>
          <p className="mt-2 flex items-center gap-3 text-sm font-medium text-slate-500">
            <span className="h-4 w-4 animate-spin rounded-full border-2 border-indigo-200 border-t-indigo-600" />
            {label}
          </p>
        </div>
      </div>

      <div className="mt-5 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="h-12 animate-pulse rounded-2xl bg-slate-100" />
        ))}
      </div>
    </section>
  );
}
